import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SimpleFormIterator,
  CheckboxGroupInput,
  ArrayInput,
  required,
  number,
  email,
  AutocompleteInput
} from 'react-admin'
/* eslint-disable-next-line */
import { withStyles } from '@material-ui/core/styles'
import { PHONES, POSTAL_CODES } from '../../configuration/validation'
import { RedirectToEntity } from '../../utils/RedirectAfterEdit'

const styles = {
  formInputContainer: {
    width: '100%'
  }
}

export const AntennaCreate = withStyles(styles)(({ classes, ...props }) => (
  <Create {...props}>
    <SimpleForm className={classes.formInputContainer} redirect={RedirectToEntity}>
      <TextInput source="name" label="Nom" validate={required()} />
      <CheckboxGroupInput
        source="flags"
        label="Propriétés"
        choices={[
          { id: 'IS_SHOWED_IN_AFFILIATION', name: "Affichée dans le parcours initial d'accompagnement / suivi" }
        ]} />
      <TextInput source="city" label="Ville" validate={required()} />
      <ReferenceInput
        label="Mission locale"
        validate={[required()]}
        source="organizationId"
        reference="organizations"
        perPage={50}
        filterToQuery={(searchText) => ({ qName: searchText })}>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <NumberInput source="position[0]" label="Longitude" validate={[required(), number()]} />
      <NumberInput source="position[1]" label="Latitude" validate={[required(), number()]} />
      <TextInput source="address" label="Adresse" />
      <TextInput source="email" label="Email" validate={[email()]} />
      <TextInput source="phone" label="Téléphone" validate={[PHONES]} />
      <ArrayInput source="postalCodes" label="Codes postaux" className={classes.formInputContainer}>
        <SimpleFormIterator>
          <TextInput label="Code postal" validate={[POSTAL_CODES]} defaultValue="" />
        </SimpleFormIterator>
      </ArrayInput>
      <TextInput source="linkAppointment" label="Lien Calendly" />
    </SimpleForm>
  </Create>
))
